.root {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacingMd);
}
